export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOGIN_EXPIRED = "LOGIN_EXPIRED";
export const SET_MESSAGE = "SET_MESSAGE";
export const ADD_ROLES = "ADD_ROLES";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
